<template>
  <div class="salary">
    <div class="salaryTitle">
      <!--          style="color: red;"-->
      <span>提示:系统自动锁定已确定提交工资数据，若要查看或者更改，请在薪资历史中查看</span>

    </div>

    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <div >
        <el-form-item label="服务组合：">
          <el-select v-model="formInline.region" style="width: 200px;" placeholder="请选择">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>


        <el-tooltip class="item" effect="light" :content="content" placement="right" style="margin-right: 30px;margin-top: 4px;" >
          <img src="@/assets/img/dataImport/yiwen.png" alt="">
        </el-tooltip><!--提示标签-->

        <el-button type="primary" size="small" @click="toEditPage()" >查看详情</el-button>
      </div>

      <div>
        <el-form-item label="薪酬组：">
          <el-select v-model="formInline.payGroupId" @change="selectGroup" style="width: 200px;margin-right: 30px;" placeholder="请选择">
            <el-option v-for="item in payGroupDataList" :key="item.id" :label="item.groupName" :value="item.id">

            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工资表模板:">
          <el-select v-model="formInline.templateId" @change="selectModel" filterable="true" style="width: 200px;" placeholder="请选择模板" :disabled="disabledTemplate">
            <el-option v-for="item in templateInfoList"
                       :key="item.id"
                       :label="item.templateName"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-tooltip class="item" effect="light" :content="contentTemplate" placement="right" style="margin-right: 30px;margin-top: 4px;" >
          <img src="@/assets/img/dataImport/yiwen.png" alt="">
        </el-tooltip>

        <el-form-item label='数据准备方式:' v-if="showRadio">
          <el-radio-group v-model="radioChange" @change="changeAction">
            <el-radio label="sysData">系统同步数据</el-radio>
            <el-radio label="oneTimeUpload">一次性导入</el-radio>
            <el-radio label="copyData">复制历史数据</el-radio>
          </el-radio-group>
        </el-form-item>

      </div>
      <div>
        <el-form-item label="名称：">
          <el-input v-model="batchInfoDetail.batchName"  @change="batchNameChange" placeholder="请输入内容" style="width: 142px;margin-right: 80px;"></el-input>
        </el-form-item>
        <el-form-item label="工资月份：" @change="wageMonthChange">
          <el-date-picker
            style="width: 142px;margin-right: 80px;"
            v-model="batchInfoDetail.wageMonth"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="社保月份：" @change="socMonthChange">
          <el-date-picker
            style="width: 142px;margin-right: 80px;"
            v-model="batchInfoDetail.socMonth"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="税金月份：" @change="taxMonthChange">
          <el-date-picker
            style="width: 142px;margin-right: 80px;"
            v-model="batchInfoDetail.taxMonth"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

      </div>
    </el-form>



  </div>
</template>

<script>
  import BspTable from "@/components/bsp/bsp-table/bsp-table";
  import BspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import { mapGetters } from 'vuex';
  import {getCusPaysetList,getCusPaybanksetList,addCusPaybanksetList,updateCusPaybanksetList,deleteCusPaybanksetData,getTaxInformationList,addTaxInformationList,updateTaxInformationList,addCusPaysetList,updateCusPaysetList,deleteCusPaysetData} from  "@/api/wage/companyTemplate";
  import {getArllTemplateInfos,getTemplateInfoListByGroupId} from "@/api/wage/batchTemplate";
  import {getPayGroupData} from "@/api/wage/payGroup";
  export default {
    name: "companyInfo",
    components:{
      BspTable,
      BspTableColumn,
    },
    computed: {
      ...mapGetters([
        'dicts',
      ]),
    },
    watch:{
      radio(){

        alert("选中"+this.radio)    //要写的方法,

      }
    },
    data(){
      return{
        role:{
          name: 'admin',
          tenantId: 'sys'
        },
        radioChange:'sysData',
        showRadio:false,
        content:'数据准备 > 数据准备 > 数据准备',
        contentTemplate:"工资表模板必选项",
        templateInfoList: [], //模板信息列表
        payGroupDataList: [], //薪酬组模板信息列表
        templateName:'',//记录所选薪资模板名
        payGroupName:'',//记录所选薪酬组模板名
        disabledTemplate:true,//薪资模板默认不可编辑
        formInline: {
          value1: '',
          region: '',
          templateId: '',//1244897053241684058默认值的意思
          payGroupId:'',//薪酬组id
          input:''
        },
        batchInfoDetail:{
          batchName:'',//批次名称
          wageMonth:'',//工资月份
          socMonth:'',//社保月份
          taxMonth:'',//税金月份
        },//页面录入的批次信息
        dialogItem:false,
        dialogItemIndex:[],
        dialogTypeIndex:null,
        dialogType:false,
        popVisible:[],//下拉框是否显示
        opens:[],//是否收起
        list:[],
        cusPaybanksetList:[],
        taxInformationList:[],
        loading:false,
        //分页查询对象
        listQuery: {
          limit: 5,
          page: 1,
          total: 0,
          tenantId: '',
        },
        cusPaybanksetlistQuery: {
          limit: 10,
          page: 1,
          total: 0,
          tenantId: '',
        },
        taxInformationlistQuery: {
          limit: 10,
          page: 1,
          total: 0,
          tenantId: '',
        },
        props: {
          // 配置项（必选）
          value: "id",
          label: "orgName",
          children: "children"
        },
        valueId: null,
        salaryList:[
          {
            titleName:'模板名称',
            required:true,
            valueId:'1234567',
            model:'一个模板'
          },
          {
            titleName:'备注',
            required:false,
            valueId:'7654321',
            model:'一个备注'
          }
        ],
        rules: {
          1234567: [
            { required: true, message: '请输入模板名称', trigger: 'blur' },
            { min: 4, max: 40, message: '长度在 4 到 40 个字符', trigger: 'blur' }
          ]
        },
        showSys:true,
        id:'',
        lists:[ //数据
          {
            title:'基本信息',
            id:'a',
            remark:"",
            self:false,
            data:[
              {
                id:"1",
                name:'雇员姓名',
                explain:'我是一段解释',
                formula:'考勤工资+绩效工资+餐补+交通补助',
                type:"黄金糕",
                fixed:2,
                btn:0
              },
              {
                id:"2",
                name:'雇员姓名',
                explain:'我是一段解释',
                formula:'',
                type:"双皮奶",
                fixed:2,
                btn:1
              },
              {
                id:"3",
                name:'雇员姓名',
                explain:'我是一段解释',
                formula:'考勤工资+绩效工资+餐补+交通补助',
                type:"蚵仔煎",
                fixed:1,
                btn:2
              }
            ]
          },
          {
            title:'工资标准',
            id:'b',
            remark:"",
            self:false,
            data:[
              {
                id:"1",
                name:'雇员姓名',
                explain:'我是一段解释',
                formula:'考勤工资+绩效工资+餐补+交通补助',
                type:"龙须面",
                fixed:1,
                btn:0
              },
              {
                id:"2",
                name:'雇员姓名',
                explain:'我是一段解释',
                formula:'',
                type:"北京烤鸭",
                fixed:1,
                btn:0
              }
            ]
          },
          {
            title:'自定义分类',
            id:'c',
            remark:"我是一段备注啊",
            self:true,
            data:[
              {
                id:"1",
                name:'雇员姓名',
                explain:'我是一段解释',
                formula:'考勤工资+绩效工资+餐补+交通补助',
                type:"北京烤鸭",
                fixed:2,
                btn:2
              },
              {
                id:"2",
                name:'雇员姓名',
                explain:'我是一段解释',
                type:"北京烤鸭",
                fixed:1,
                formula:'',
                btn:2
              },
              {
                id:"3",
                name:'雇员姓名',
                explain:'我是一段解释',
                formula:'考勤工资+绩效工资+餐补+交通补助',
                type:"北京烤鸭",
                fixed:1,
                btn:2
              }
            ]
          }
        ],
        checked:[
          [],
          ['b1'],
          ['c3']
        ],
        checkLists:[
          {
            id:'check1',
            checkList:[{id:'a1',value:'雇员编号1'},{id:'a2',value:'证件类型'},{id:'a3',value:'银行卡开户名'},{id:'a4',value:'银行卡账号'},{id:'a5',value:'银行类别'}]
          },
          {
            id:'check2',
            checkList:[{id:'b1',value:'雇员编号2'},{id:'b2',value:'证件类型'},{id:'b3',value:'银行卡开户名'},{id:'b4',value:'银行卡账号'},{id:'b5',value:'银行类别'}]
          },
          {
            id:'check3',
            checkList:[{id:'c1',value:'雇员编号3'},{id:'c2',value:'证件类型'},{id:'c3',value:'银行卡开户名'},{id:'c4',value:'银行卡账号'},{id:'c5',value:'银行类别'}]
          }
        ],
        listForm:{
          fileIds:'',
          photo:'',
          fileId:'',
        },
        cusPaybanksetListForm:{
          fileIds:'',
          photo:'',
          fileId:'',
        },
        taxInformationListForm:{
          fileIds:'',
          photo:'',
          fileId:'',
        },
        textMap: {
          addCusPayset: '新增计薪规则',
          updateCusPayset: '编辑计薪规则',
          addCusPaybankset: '新增付款方信息',
          updateCusPaybankset: '编辑付款方信息',
          addTaxInformation: '新增税务信息',
          updateTaxInformation: '编辑税务信息'
        },
        dialogStatus: 'addCusPayset',
        dialogFormVisible: false,
        cusPaybanksetFormVisible: false,
        cusPaysetFormVisible: false,
        taxInformationFormVisible: false,
        typeForm: {
          id:'',
          name: "",
          typeTextarea: "",
          self:true,
          data:{}
        },
        itemForm:{
          id:'',
          name:"",
          itemSelect:'',
          itemRadio:1,
          itemTextarea:''
        },
        options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
      }
    },
    created(){
      this.getTemplateInfoList();
      this.getPayGroupData();
      /*const len = this.lists.length;
      for(var i = 0;i<len;i++){
        this.popVisible.push({visible:false})
        this.opens.push({open:true})
      }*/
    },
    methods:{
      //获取薪酬组数据
      getPayGroupData(){
        let params = {};
        getPayGroupData(params).then(res=>{
          let rs=res.data
          if(rs.code==0){
            this.payGroupDataList=rs.data
          }else{
            this.$message.error('获取薪酬组信息列表失败')
          }
        })
      },
      getTemplateInfoList(){
        getArllTemplateInfos().then(res=>{
          let rs=res.data
          if(rs.code==0){
            this.templateInfoList=rs.data
          }else{
            this.$message.error('获取模板信息列表失败')
          }
        })
      },
      getTemplateInfoListByGroupId(id){
        getTemplateInfoListByGroupId(id).then(res=>{
          let rs=res.data
          if(rs.code==0){
            this.templateInfoList=rs.data
            this.disabledTemplate = false;//薪资模板可编辑
          }else{
            this.$message.error('获取模板信息列表失败')
          }
        })
      },
      selectGroup(id){//获取传入的id至
        /*if(id!=null && id.length!=0){
          this.show=true;
        }else{ disabled
          this.showRadio=false;
        }*/
        let obj = {};
        obj = this.payGroupDataList.find(item=>{
          return item.id == id;//筛选出匹配的数据
        });
        this.payGroupName = obj.groupName;//给模板名赋值为选中项
        this.getTemplateInfoListByGroupId(id);//级联薪资模板下拉框

      },
      selectModel(id){//获取传入的id至
        if(id!=null && id.length!=0){
          this.showRadio=true;
        }else{
          this.showRadio=false;
        }
        let obj = {};
        obj = this.templateInfoList.find(item=>{
          return item.id == id;//筛选出匹配的数据
        });
        this.templateName = obj.templateName;//给模板名赋值为选中项
      },
      changeAction(value){
       // this.radioChange=value;//更改选中的状态
        this.$set(this,"radioChange",value);
        if('oneTimeUpload'==value){//判断如果传入的值是一次性导入的跳转到一次性导入页面
          this.oneTimeUploadPage();
        }
      },
      batchNameChange(value){
//
      },
      //跳转一次性上传页面
      oneTimeUploadPage(){
        const query = {
          templateId:this.formInline.templateId,
          templateName:this.templateName,
          templateInfoList:this.templateInfoList,
          payGroupId:this.formInline.payGroupId,
          payGroupName:this.payGroupName,
          payGroupDataList:this.payGroupDataList,
          batchInfoDetail:this.batchInfoDetail
        }
        console.log("编辑参数query=",query);
        this.$router.push({ path: '/onetime-upload', query});
      },
      //计薪删除
      cusPaysetDeleteRow(row){
        this.id = row.id;
        deleteCusPaysetData(this.id).then(res=>{
          this.$message.success("删除成功");
          this._getCusPaysetListpage();
        })
      }, //付款删除
      cusPaybanksetDeleteRow(row){
        this.id = row.id;
        deleteCusPaybanksetData(row.id).then(res=>{
          this.$message.success("删除成功");
          this._getCusPaybanksetListpage();
        })
      },
      //计薪编辑
      cusPaysetEditRow(row){
        //展示编辑表单框
          this.cusPaysetFormVisible = true
          this.dialogStatus='updateCusPayset'
          this.listForm = row
      }, //付费编辑
      cusPaybanksetEditRow(row){
        //展示编辑表单框
          this.cusPaybanksetFormVisible = true
          this.dialogStatus='updateCusPaybankset'
          this.cusPaybanksetListForm = row
      }, //公司税务信息编辑
      taxInformationEditRow(row){
        //展示编辑表单框
          this.taxInformationFormVisible = true
          this.dialogStatus='updateTaxInformation'
          this.taxInformationListForm = row
      },
      //计薪查询
      _getCusPaysetListpage(){
        this.loading = true;
        // alert("计薪查询");
        getCusPaysetList(this.listQuery).then((res) => {
          this.listQuery.total = res.data.total
          this.list = res.data.records
          this.loading=false
        })
      },//付款方信息查询
      _getCusPaybanksetListpage(){
        this.loading = true;
        // alert("计薪查询");
        getCusPaybanksetList(this.cusPaybanksetlistQuery).then((res) => {
          this.cusPaybanksetlistQuery.total = res.data.total
          this.cusPaybanksetList = res.data.records
          this.loading=false
        })
      },//公司税务方信息查询
      _getTaxInformationListpage(){
        this.loading = true;
        // alert("计薪查询");
        getTaxInformationList(this.taxInformationlistQuery).then((res) => {
          this.taxInformationlistQuery.total = res.data.total
          this.taxInformationList = res.data.records
          this.loading=false
        })
      },
      //启用和禁用方法
      changeStatus(row,status){
          let param={
            id: row.id,
            status: status
          }
          updateTaxInformationList(param).then(res =>{
            // this.$message(""res.data.msg"")
            /*if('1'==status){
            }else if('0'==status){

            }*/
            this.$message.success('操作成功');
            this._getTaxInformationListpage();
          })
      },
      //计薪保存方法:
      handlerCusPaysetListForm(){
        let childForm = this.$refs.cusPaysetForm.$refs.listForm
        if (this.dialogStatus == 'addCusPayset') {
          childForm.validate((valid) => {
            if (valid) {
              debugger;
              addCusPaysetList(this.listForm).then(res => {
                this.cusPaysetFormVisible = false
                this.$message.success('新增成功');
                this._getCusPaysetListpage();
              })
            }
          });
        } else if (this.dialogStatus == 'updateCusPayset') {
          childForm.validate((valid) => {
            if (valid) {
              updateCusPaysetList(this.listForm).then(res => {
                this.cusPaysetFormVisible = false
                this.$message.success('修改成功');
                this._getCusPaysetListpage();
              })
            }
          })
        }
      }, //付款保存方法:
      handlerCusPaybanksetListForm(){
        let childForm = this.$refs.cusPaybanksetForm.$refs.listForm
        if (this.dialogStatus == 'addCusPaybankset') {
          childForm.validate((valid) => {
            if (valid) {
              addCusPaybanksetList(this.cusPaybanksetListForm).then(res => {
                this.cusPaybanksetFormVisible = false
                this.$message.success('新增成功');
                this._getCusPaybanksetListpage();
              })
            }
          });
        } else if (this.dialogStatus == 'updateCusPaybankset') {
          childForm.validate((valid) => {
            if (valid) {
              updateCusPaybanksetList(this.cusPaybanksetListForm).then(res => {
                this.cusPaybanksetFormVisible = false
                this.$message.success('修改成功');
                this._getCusPaybanksetListpage();
              })
            }
          })
        }
      },//公司税务保存方法:
      handlertaxInformationListForm(){
        //这个refs就是ref
        let childForm = this.$refs.taxInformationForm.$refs.listForm
        if (this.dialogStatus == 'addTaxInformation') {
          childForm.validate((valid) => {
            if (valid) {
              addTaxInformationList(this.taxInformationListForm).then(res => {
                this.taxInformationFormVisible = false
                this.$message.success('新增成功');
                this._getTaxInformationListpage();
              })
            }
          });
        } else if (this.dialogStatus == 'updateTaxInformation') {
          childForm.validate((valid) => {
            if (valid) {
              updateTaxInformationList(this.taxInformationListForm).then(res => {
                this.taxInformationFormVisible = false
                this.$message.success('修改成功');
                this._getTaxInformationListpage();
              })
            }
          })
        }
      },
      changeOpen(index){
        this.$set(this.opens[index],"open",!this.opens[index].open)
      },
      changeItem(checked,index){// checked是所有的选中值，index是当前选择框组的序号,当前选择组为checked[index]
        console.log(checked[index])
      },
      // 新增行
      addItem(index){
        this.dialogItem = true
        this.dialogItemIndex = [index,this.lists[index].data.length]
      },
      //展示发薪信息新增表格
      showCustPaysetAddList(){
        this.listForm = {}
        this.cusPaysetFormVisible = true
        this.dialogStatus='addCusPayset'
      },
      //展示付款方信息新增表格
      showCustPaybanksetAddList(){
        this.listForm = {}
        this.cusPaybanksetFormVisible = true
        this.dialogStatus='addCusPaybankset'
      },

      //展示公司税务信息新增表格
      showTaxInformationAddList(){
        this.listForm = {}
        this.taxInformationFormVisible = true
        this.dialogStatus='addTaxInformation'
      },

      // 编辑行
      salaryEdit(index,itemIndex){
        this.$set(this.itemForm,"id",this.lists[index].data[itemIndex].id)
        this.$set(this.itemForm,"name",this.lists[index].data[itemIndex].name)
        this.$set(this.itemForm,"itemTextarea",this.lists[index].data[itemIndex].explain)
        this.$set(this.itemForm,"itemSelect",this.lists[index].data[itemIndex].type)
        this.$set(this.itemForm,"itemRadio",this.lists[index].data[itemIndex].fixed)
        this.dialogItem = true
        this.dialogItemIndex = [index,itemIndex]
      },
      // 编辑类别
      editType(index){
        this.dialogType = true
        this.$set(this.typeForm,"id", this.lists[index].id);
        this.$set(this.typeForm,"name", this.lists[index].title);
        this.$set(this.typeForm,"itemTextarea" , this.lists[index].remark);
        this.$set(this.typeForm,"self" ,  this.lists[index].self);
        this.$set(this.typeForm,"data" ,  this.lists[index].data);
        this.dialogTypeIndex=index
      },
      dialogItemClose(){
        this.$refs.itemForm.resetFields();
        this.dialogItem = false
      },
      dialogTypeClose(){
        this.$refs.typeForm.resetFields();
        this.dialogType = false
      },
      // 保存一行
      dialogItemSave(){
        // 保存
        let [index,itemIndex] = this.dialogItemIndex;
        let data = {}
        data.id = this.itemForm.id;
        data.name = this.itemForm.name;
        data.type = this.itemForm.itemSelect;
        data.fixed = this.itemForm.itemRadio;
        data.explain = this.itemForm.itemTextarea;
        data.formula = "";
        data.btn = 2 ;// 可编辑
        this.$set(this.lists[index].data,itemIndex,data)

        this.$refs.itemForm.resetFields()
        this.dialogItem = false
      },
      //新增分类
      addType(){
        this.dialogType = true
        this.dialogTypeIndex = this.lists.length
      },
      // 保存分类
      dialogTypeSave(){
        // 保存
        let index = this.dialogTypeIndex;
        let data = {}
        data.id = this.typeForm.id;
        data.title = this.typeForm.name;
        data.remark = this.typeForm.itemTextarea;
        data.self = true;
        data.data = this.typeForm.data;
        this.$set(this.lists,index,data)
        this.$set(this.popVisible,index,{visible:false})
        this.$set(this.opens,index,{open:true})
        const checkList ={
          id:'check4',
          checkList:[{id:'d1',value:'雇员编号1'},{id:'d2',value:'证件类型'},{id:'d3',value:'银行卡开户名'},{id:'d4',value:'银行卡账号'},{id:'d5',value:'银行类别'}]
        }
        this.$set(this.checkLists,index,checkList)
        this.$set(this.checked,index,[])
        this.$refs.typeForm.resetFields();
        this.dialogType = false
      },
      // 删除一行
      deleteData(index,indexItem){
        this.lists[index].data.splice(indexItem, 1);
      },
      // 删除类别
      deleteType(index){
        this.lists.splice(index, 1);
      },
      toEditPage(){
        const query = {
          templateId:this.formInline.templateId
        }
        console.log("详情参数query=",query);
        this.$router.push({ path: '/wage/salaryDetailTabs', query});
      }
    }
  };
</script>

<style scoped>
  .el-switch{
    margin-top: 0;
  }
  .salaryItem{
    padding:0 20px;
  }
  .salaryItemHeader{
    display: flex;
    margin-top: 20px;
    background-color: #efefef;
    line-height: 40px;
    color:#999;
    font-size: 16px;
    padding-left: 34px;
    padding-right: 30px;
    display: flex;
    justify-content: space-between;
  }
  .salarySelected{
    display: flex;
    margin-top: 20px;
    /*background-color: #efefef;*/
    width:1200px;
    line-height: 40px;
    color:#000000;
    font-size: 16px;
    padding-left: 34px;
    padding-right: 30px;
    display: flex;
    justify-content: space-between;
  }
  .salaryTex{
    display: flex;
    margin-top: 20px;
    /*background-color: #efefef;*/
    width:500px;
    line-height: 40px;
    color:#000000;
    font-size: 16px;
    padding-left: 34px;
    padding-right: 30px;
    display: flex;
    justify-content: space-between;
  }
  .salaryItemHeaderL{
    padding-left: 26px;
    margin-top: 20px;
    font-size: 16px;
  }
  .salaryItemHeaderR{
    display: flex;
    justify-content: flex-end;
    color:#bbbbbb;
  }
  .salaryCheck{
    margin-right: 25px;
    padding: 0 5px;
  }
  .salaryCheckActve{
    background-color: #fff;
  }
  .salaryLine{
    border-bottom:1px solid #efefef;
    line-height: 40px;
    padding: 0 30px 0 34px;
  }
  .salaryLine svg{
    font-size: 16px;
  }
  /*.salaryTitle svg{*/
  /*  margin-right: 10px;*/
  /*}*/
  .salaryTitle .zhanwei{
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
  .salaryTitle{
    /*color:#000000;*/
    color:#FF9600;
    height: 40px;
    font-size: 14px;
    display: flex;
    align-items: center;
    background-color: #DDF4FF;
  }
  .salaryTitle svg{
    color:#FF9600;
  }
  .salaryExplain{
    font-size: 12px;
    color: #999999;
    padding: 10px;
    line-height: 20px;
  }
  .salaryFormula {
    color: #008AFF;
    font-size: 12px;
    cursor: pointer;
  }
  .hasFormula{
    color:#999999;
    cursor: auto;
  }
  .salaryFormula svg{
    margin-right: 10px;
    color:#008AFF;
  }
  .hasFormula svg{
    color:#75CF00;
  }
  .salaryBtn{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 40px;
    color:#008AFF;
  }
  .salaryBtnEdit{
    margin-right: 30px;
  }
  .salaryBtn svg{
    cursor: pointer;
  }
  .salaryItemHeaderC{
    color: #999999;
    font-size: 12px;
  }
  .salaryItemHeaderR div{
    cursor: pointer;
    margin-right: 30px;
  }
  .salaryItemHeaderR div:last-child{
    margin-right: 0px;
  }

  .addItem{
    margin: 20px auto 0;
    width: 160px;
    height: 30px;
    background-color: #DDDDDD;
    border-radius: 20px;
    font-size: 12px;
    color:#008AFF;
    align:center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .addItem svg{
    margin-right: 10px;
    font-size: 16px;
  }
  .salaryChecks>>>.el-checkbox{
    display: flex;
    align-items: center;
    margin-right: 0;
  }
  .salaryChecks>>>.el-checkbox__label{
    line-height: 26px;
    color:#000000;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 120px;
  }
  .salaryChecks>>>.el-checkbox__input{
    margin-top: 2px;
  }
  .addCheck{
    cursor: pointer;
    width: 120px;
    height: 30px;
    font-size: 12px;
    color:#008AFF;
    background: #EFEFEF;
    border-radius: 20px;
    text-align: center;
    line-height: 30px;
    margin: 10px auto 0;
  }
  .el-radio-group{
    margin: 0;
    height: 30px;
    display: flex;
    align-items: center;
  }
</style>
<style>
  .salaryCheckPop{
    min-width: 120px;
  }
  .salaryCheckPop .popper__arrow{
    display: none;
  }
</style>
